import { GlobalOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { SUPPORTED_LOCALES } from '../../i18n';
import classes from './language-switcher.module.scss';

const LANGUAGE_LABELS = {
    en: 'English',
    ar: 'العربية',
    he: 'עברית',
    es: 'Español'
} as const;

export default function LanguageSwitcher() {
    const { t } = useTranslation();
    const { locale = 'en' } = useParams<{ locale: string }>();
    const location = useLocation();
    const navigate = useNavigate();

    const changeLanguage = (nextLocale: string) => {
        const pathWithoutLocale = location.pathname.replace(/^\/[^/]+/, '') || '/';
        navigate(`/${nextLocale}${pathWithoutLocale}${location.search}`, { replace: true });
    };

    const items: MenuProps['items'] = SUPPORTED_LOCALES.map((supportedLocale) => ({
        key: supportedLocale,
        label: LANGUAGE_LABELS[supportedLocale]
    }));

    return (
        <Dropdown
            menu={{
                items,
                selectedKeys: [locale],
                onClick: ({ key }) => changeLanguage(key)
            }}
            placement="bottomRight"
            trigger={['click']}
        >
            <Button
                className={classes.switcher}
                type="text"
                icon={<GlobalOutlined />}
                aria-label={t('common.change-language')}
            >
                {LANGUAGE_LABELS[locale as keyof typeof LANGUAGE_LABELS] || LANGUAGE_LABELS.en}
            </Button>
        </Dropdown>
    );
}
